import { Enablesaveuseraccessdto } from './../../model/enablesaveuseraccessdto';
import { Component, OnInit } from '@angular/core';
import { EdiDunsMaster } from 'src/app/model/ediDunsMaster';
import { HttpclientService } from 'src/app/services/httpclient.service';
import { FileExportService } from 'src/app/services/file-export.service';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { PoOrderByPipe } from 'src/app/pipes/po-order-by.pipe';
import { PdfFileService } from 'src/app/services/pdf-file.service';
import { ExcelFileService } from 'src/app/services/excel-file.service';
import { DatePipe } from '@angular/common';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog.service';
declare var $: any;
@Component({
  selector: 'app-duns-id',
  templateUrl: './duns-id.component.html',
  styleUrls: ['./duns-id.component.css']
})
export class DunsIdComponent implements OnInit {

  public loading: boolean;
  selectedpartner : String = "";
  selectedpartnerid : String = "";
  partners : any;
  search: string = "";
  selectedAllRow: boolean;
  addingdunsmaster: boolean=false;
  modalPopupToAdd : boolean=false;
  config: any;
  count: number = 25;
  exportList: string[] = ['PDF', 'Excel'];
  selectedEdiDunsMasters: any = [];
  exportModal: string;
  modalPopup : boolean=false;
  modalPopupToDelete: boolean=false;
  edduns: EdiDunsMaster[];
  serachdetails: EdiDunsMaster[];
  eddunsdetails: EdiDunsMaster[];
  clonededdunsDetails: EdiDunsMaster[];
  dunsIdToBeDeleted: string;
  dunsObjToBeDeleted : EdiDunsMaster;
  public intialEdiDunsMasterList: EdiDunsMaster[];
  isDeleted : string ;
  isAdded: string ;
  ediTpIdAdd: string ;
  sapPayerNumAdd: string ;
  custNameAdd: string ;
  
  isdunsupdated : string="";
  updatededidunsmaster : boolean;
  ediTpId:string;
  sapPayerNum:string;
  custName:string;

  isEdiTpIdSortCollapsedUpArrow:boolean;
  isEdiTpIdSortCollapsedDownArrow:boolean;

  isSapPayerNumSortCollapsedUpArrow:boolean;
  isSapPayerNumSortCollapsedDownArrow:boolean;

  isCustNameSortCollapsedUpArrow:boolean;
  isCustNameSortCollapsedDownArrow:boolean;

  constructor(private httpclientService: HttpclientService,public fileExportService: FileExportService,
    public appSettingService: AppSettingService,private pipe: PoOrderByPipe,public pdfFileService: PdfFileService,
    public excelFileService: ExcelFileService, public datePipe: DatePipe,private confirmDialogService: ConfirmDialogService) { 
    this.config = {
      currentPage: 1,
      itemsPerPage: 25
    };
  }

  
  ngOnInit() {
    $(document).ready(
      () => {
        let searchInp = $(".searchContr .searchInput");
        let searchCloseIcon = $(".searchCloseIcon")
        $(searchInp).on("focus", function () {
          $(".searchIcon").addClass("searchIconActive")
          $(".searchCloseIcon").fadeIn("slow")
        })
        $(searchInp).on("blur", function () {
          $(".searchIcon").removeClass("searchIconActive")
          $(".searchCloseIcon").fadeOut("slow")
        })
        $(searchCloseIcon).hover(function () {
          $(searchCloseIcon).toggleClass("searchCloseIconFocus")
        })
        $(searchCloseIcon).on("click", function () {
          $(".searchContr .searchCloseIcon").val("");
          $(".searchInput").val("");

        })
        
      }
    ) 

    this.getPartnerDataList();
  //   this.loading=true;
  //   this.httpclientService.getPartnerListMSO().subscribe(
  //     data => {
  //       this.partners = data;
  //     }
  // );
  this.exportModal = this.appSettingService.exportList[0];
  this.onSearch();
  this.fileExportService.selectedEdiDunsMasterData = [];
  }
  deleteDunsid(data){
    this.isDeleted="";
    this.dunsIdToBeDeleted="";
    this.modalPopupToDelete=true;
    this.dunsIdToBeDeleted=data.ediTpId;
    this.dunsObjToBeDeleted=data;
    
  }
  pressingOKToDelete(){
    this.modalPopupToDelete=false;
    this.isDeleted="";
    this.loading = true;
    this.httpclientService.deleteDunsId(this.dunsIdToBeDeleted).subscribe(
      data => {
        this.isDeleted=data.isSaved;
        this.loading = false;
        this.eddunsdetails = this.eddunsdetails.filter(u => u !== this.dunsObjToBeDeleted);
        

      }
    );
   
  }
  pressingCancelNotToDelete(){
    this.modalPopupToDelete=false;
    
  }
  enablingToAddDunsid(){
    this.addingdunsmaster=true;
    this.updatededidunsmaster=false;
    this.isDeleted="";
    this.isAdded="";
    
  }
  
  addDunsId(ediTpIdAdd,sapPayerNumAdd,custNameAdd){
    this.isAdded="";
    console.log("ediTpIdAdd >> "+ediTpIdAdd)
    console.log(ediTpIdAdd.value,sapPayerNumAdd.value,custNameAdd.value);
    if(ediTpIdAdd.value=="" || ediTpIdAdd.value==null || ediTpIdAdd.value==undefined){
      this.isAdded="Please Enter EDI TP ID";
      return;
    }
    if(sapPayerNumAdd.value=="" || sapPayerNumAdd.value==null || sapPayerNumAdd.value==undefined){
      this.isAdded="Please Enter SAP Payer No";
      return;
    }
    if(custNameAdd.value=="" || custNameAdd.value==null || custNameAdd.value==undefined){
      this.isAdded="Please Enter Customer Name";
      return;
    }
    var dunsIdObj   = new EdiDunsMaster(ediTpIdAdd.value,sapPayerNumAdd.value,custNameAdd.value);
    this.loading = true;
    this.httpclientService.addDunsId(dunsIdObj).subscribe(
      data => {
        this.isAdded=data.isSaved;
        this.loading = false;
        ediTpIdAdd.viewModel="";
        sapPayerNumAdd.viewModel="";
        custNameAdd.viewModel="";
      }
    );
  }
  cancelAddingDunsid(){
    this.modalPopupToAdd=true;
    
    
    
  }
  pressingOKToAdd(){
    this.modalPopupToAdd=false;
    this.updatededidunsmaster=false;
    this.addingdunsmaster=false;
    this.isAdded="";
    this.ngOnInit();
  }
  pressingCancelNotToAdd(){
    this.modalPopupToAdd=false;
    
  }
  getPartnerDataList() {
    this.loading = true;
    if (this.appSettingService.partnerMSOGlobelList === null || this.appSettingService.partnerMSOGlobelList === undefined ) {
      this.httpclientService.getPartnerList().subscribe(
        data => {
          this.appSettingService.partnerMSOGlobelList = data;
          this.partners = data;
          this.loading = false;
        }
      );

      console.log('Partner is null from backend' + this.appSettingService.partnerMSOGlobelList);
      } else {
        this.partners = this.appSettingService.partnerMSOGlobelList;
        this.loading = false;
        console.log('Partner is not null from frontend' + this.appSettingService.partnerMSOGlobelList);
      }
  }
  pressingOK(){
    this.modalPopup=false;
    this.updatededidunsmaster = false;
    this.search="";
    // this.onSearch();
    this.ngOnInit();

  }
  pressingCancel(){
    this.modalPopup=false;
  }

  ChangeSortOrder(exportData) {
    this.exportModal = exportData;
  }

  modalPopupExport : boolean=false;
  modalPopupString: string;
  pressingOKExport(){
    this.modalPopupExport=false;
  }

  export() {
    this.isDeleted="";
    if(this.eddunsdetails == null || this.eddunsdetails == undefined || this.eddunsdetails.length == 0){
      this.modalPopupString="No Data to Export";
      this.modalPopupExport=true;
      return;
    }
  let flag:boolean=false;
    if (this.fileExportService.selectedEdiDunsMasterData.length === 0) {
      flag=true;
      this.edduns = [];
      this.eddunsdetails.forEach(pdto => {
        pdto.rowCheck = true;
        this.edduns.push(pdto);
      });
      this.eddunsdetails = this.edduns;
      this.fileExportService.selectedEdiDunsMasterData = this.edduns;
    } 
      if (this.exportModal === 'PDF') {
        this.pdfFileService.exportDunsIdTable('DUNS ID Table');
      } else if (this.exportModal === 'Excel') {
        this.selectedEdiDunsMasters = [];
        this.fileExportService.selectedEdiDunsMasterData.forEach(pdto => {
          if (pdto.rowCheck) {
            this.selectedEdiDunsMasters.push({
             'EDI TP ID': `${pdto.ediTpId}`,
              'SAP Payer': `${pdto.sapPayerNum}`, 'Customer Name': `` + `${pdto.custName}`
            });
          }
        });
        this.excelFileService.exportDunsIdTableExcel(this.selectedEdiDunsMasters, 'DUNS ID Table');
      }
      if(flag){
        this.edduns = [];
        this.eddunsdetails.forEach(pdto => {
          pdto.rowCheck = false;
          this.edduns.push(pdto);
        });
        this.eddunsdetails = this.edduns;
        this.fileExportService.selectedEdiDunsMasterData = [];
      }
  }

  pageChanged(event) {
    this.config.currentPage = event;
  }

  changerecordperpage(value) {

    this.config.itemsPerPage = value;
    this.count = value;
  }
  filteredData : any[]=[];

  onChangePartner(){
    this.filteredData =[];
    this.selectedpartnerid=null
    if(this.intialEdiDunsMasterList==undefined||this.intialEdiDunsMasterList==null||this.intialEdiDunsMasterList.length<1)
    {
      this.loading = true;
      this.httpclientService.getEdiDunsMasterDetails(this.search).then(
        (data)=> {
          this.loading = false;
            this.serachdetails=data;
            this.intialEdiDunsMasterList = data;
            this.eddunsdetails=[];
            this.eddunsdetails=this.serachdetails;
            this.clonededdunsDetails= Object.assign([{}], this.serachdetails);
            this.clearAllSort();
      this.partners.forEach(element => {
        if(element.partnerName==this.selectedpartner)
        this.selectedpartnerid=element.partnerNumber;
      });
    this.intialEdiDunsMasterList.forEach(element => {
    if(this.selectedpartnerid!=undefined&&this.selectedpartnerid!=null&&element.ediTpId==this.selectedpartnerid)
    this.filteredData.push(element);
  });
  this.eddunsdetails=[];
  if(this.filteredData!=null&&this.filteredData.length>0){
    this.serachdetails=this.filteredData;
            this.eddunsdetails=this.serachdetails;
            this.clonededdunsDetails= Object.assign([{}], this.serachdetails);
            this.clearAllSort();
  }else if(this.selectedpartnerid==undefined||this.selectedpartnerid==null){
    this.serachdetails=this.intialEdiDunsMasterList;
    this.eddunsdetails=this.serachdetails;
    this.clonededdunsDetails= Object.assign([{}], this.serachdetails);
    this.clearAllSort();
  }
}
)
    }else{
      this.partners.forEach(element => {
        if(element.partnerName==this.selectedpartner)
        this.selectedpartnerid=element.partnerNumber;
      });
    this.intialEdiDunsMasterList.forEach(element => {
    if(this.selectedpartnerid!=undefined&&this.selectedpartnerid!=null&&element.ediTpId==this.selectedpartnerid)
    this.filteredData.push(element);
  });
  this.eddunsdetails=[];
  if(this.filteredData!=null&&this.filteredData.length>0){
    this.serachdetails=this.filteredData;
            this.eddunsdetails=this.serachdetails;
            this.clonededdunsDetails= Object.assign([{}], this.serachdetails);
            this.clearAllSort();
  }else if(this.selectedpartnerid==undefined||this.selectedpartnerid==null){
    this.serachdetails=this.intialEdiDunsMasterList;
    this.eddunsdetails=this.serachdetails;
    this.clonededdunsDetails= Object.assign([{}], this.serachdetails);
    this.clearAllSort();
  }
    }
  }
  cancelsearch(){
    this.isBlank=""
    this.search="";
    this.eddunsdetails=this.clonededdunsDetails;
  }
  
  onChangeSearch(){
    this.selectedpartner="Pick a Partner";
  }
  clearMessage(){
    this.isBlank=""
    this.isDeleted="";
    
  }
  isBlank : string="";
  onSearch1(searchingData){
    if(searchingData.value === "" || searchingData.value === undefined || searchingData.value === null){
      this.isBlank="Please Enter Searching Data";
      return;
    }
    this.eddunsdetails=this.intialEdiDunsMasterList;
    var filteredSerachDetails: EdiDunsMaster[]=[];
    var inputSearchingData = searchingData.value;
    var inputSearchingDataCheck = inputSearchingData.toLowerCase();
    var ediTpId,custName,sapPayerNum;
    
    for(var dunsDetails of this.eddunsdetails){
      if(dunsDetails.ediTpId != null && dunsDetails.ediTpId != undefined && dunsDetails.ediTpId !=""){
        ediTpId =dunsDetails.ediTpId.toLowerCase();
      }else{
        ediTpId="";
      }
    if(dunsDetails.custName != null && dunsDetails.custName != undefined && dunsDetails.custName !=""){
      custName = dunsDetails.custName.toLowerCase();
      }else{
        custName="";
      }
    if(dunsDetails.sapPayerNum != null && dunsDetails.sapPayerNum != undefined && dunsDetails.sapPayerNum !=""){
      sapPayerNum = dunsDetails.sapPayerNum.toLowerCase();
      }else{
        sapPayerNum="";
      }
      if(ediTpId.includes(inputSearchingDataCheck)){
        filteredSerachDetails.push(dunsDetails);
      }
      else if(sapPayerNum.includes(inputSearchingDataCheck)){
        filteredSerachDetails.push(dunsDetails);
      }
      else if(custName.includes(inputSearchingDataCheck)){
        filteredSerachDetails.push(dunsDetails);
      }
      
     }
    let size = filteredSerachDetails.length;
    if(size !=0){
    this.eddunsdetails=[];
    this.eddunsdetails=filteredSerachDetails;
    }else{
      this.isBlank="No Record Found";
      this.eddunsdetails=this.intialEdiDunsMasterList;
    }

  }
  onSearch(){
    this.clearAllSelection(); 
    // if(this.search != undefined && this.search != null && this.search != "" ){
      if(this.search != undefined && this.search != null){
      this.loading=true;
    this.httpclientService.getEdiDunsMasterDetails(this.search).then(
      data => {
        this.selectedpartner="";
        this.loading=false;
          this.serachdetails=data;
          this.intialEdiDunsMasterList = data;
          this.eddunsdetails=[];
          this.eddunsdetails=this.serachdetails;
          this.clonededdunsDetails= Object.assign([{}], this.serachdetails);
          this.clearAllSort();
      }
  )}
  }

  clearAllSort() {
    this.isEdiTpIdSortCollapsedUpArrow=true;
    this.isEdiTpIdSortCollapsedDownArrow=true;
    this.isSapPayerNumSortCollapsedUpArrow=true;
    this.isSapPayerNumSortCollapsedDownArrow=true;
    this.isCustNameSortCollapsedUpArrow=true;
    this.isCustNameSortCollapsedDownArrow=true;
  }
  cleareddunsSelection: EdiDunsMaster[];
  clearAllSelection() {
    this.selectedAllRow = false;
    this.cleareddunsSelection = [];
    if(this.eddunsdetails!=null && this.eddunsdetails.length>0){
      this.eddunsdetails.forEach(pdto => {
        pdto.rowCheck = false;
        this.cleareddunsSelection.push(pdto);
      });
    }
    
    this.eddunsdetails = this.cleareddunsSelection;
  }

  onSelectAllEdi(values: any) {
    this.isDeleted="";
    this.edduns = [];
    if (values.currentTarget.checked) {
      this.eddunsdetails.forEach(pdto => {
        pdto.rowCheck = true;
        this.edduns.push(pdto);
      });
      this.eddunsdetails = this.edduns;
      this.fileExportService.selectedEdiDunsMasterData = this.edduns;
    } else {
      this.eddunsdetails.forEach(pdto => {
        console.log('...' + pdto.rowCheck);
        pdto.rowCheck = false;
        this.edduns.push(pdto);
      });
      this.eddunsdetails = this.edduns;
      this.fileExportService.selectedEdiDunsMasterData = [];
    }

  }

  onSelect(selectedItem: any, values: any) {
    this.isDeleted="";
    let checkStaus = true;
    if (values.currentTarget.checked) {

      this.fileExportService.selectedEdiDunsMasterData.push(selectedItem);
    } else if (!values.currentTarget.checked) {

      this.fileExportService.selectedEdiDunsMasterData = this.fileExportService.selectedEdiDunsMasterData.filter(obj => obj !== selectedItem);
     
    }

    if(this.fileExportService.selectedEdiDunsMasterData.length === this.eddunsdetails.length){
      this.selectedAllRow = true;
    }else{ 
      this.selectedAllRow = false;
    }
    

}

  sortArry: EdiDunsMaster[];
  onChangeSort(event: any, upDown: boolean, propertyName: string) {
    this.isDeleted="";
    this.intialEdiDunsMasterList= this.eddunsdetails;
    if (propertyName === 'ediTpId' ) {
    this.isCustNameSortCollapsedUpArrow=true;
    this.isCustNameSortCollapsedDownArrow=true;
    this.isSapPayerNumSortCollapsedUpArrow=true;
    this.isSapPayerNumSortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialEdiDunsMasterList, propertyName, true);
    this.eddunsdetails = [];
    this.eddunsdetails = this.sortArry;
    this.isEdiTpIdSortCollapsedUpArrow = !this.isEdiTpIdSortCollapsedUpArrow;
    this.isEdiTpIdSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialEdiDunsMasterList, propertyName, false);
  this.eddunsdetails = [];
  this.eddunsdetails = this.sortArry;
  this.isEdiTpIdSortCollapsedDownArrow = !this.isEdiTpIdSortCollapsedDownArrow;
  this.isEdiTpIdSortCollapsedUpArrow = true;
} 
  }else if (propertyName === 'sapPayerNum' ) {
    this.isCustNameSortCollapsedUpArrow=true;
    this.isCustNameSortCollapsedDownArrow=true;
    this.isEdiTpIdSortCollapsedUpArrow=true;
    this.isEdiTpIdSortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialEdiDunsMasterList, propertyName, true);
    this.eddunsdetails = [];
    this.eddunsdetails = this.sortArry;
    this.isSapPayerNumSortCollapsedUpArrow = !this.isSapPayerNumSortCollapsedUpArrow;
    this.isSapPayerNumSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialEdiDunsMasterList, propertyName, false);
  this.eddunsdetails = [];
  this.eddunsdetails = this.sortArry;
  this.isSapPayerNumSortCollapsedDownArrow = !this.isSapPayerNumSortCollapsedDownArrow;
  this.isSapPayerNumSortCollapsedUpArrow = true;
} 
  } else if (propertyName === 'custName' ) {
 
    this.isEdiTpIdSortCollapsedUpArrow=true;
    this.isEdiTpIdSortCollapsedDownArrow=true;
    this.isSapPayerNumSortCollapsedUpArrow=true;
    this.isSapPayerNumSortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialEdiDunsMasterList, propertyName, true);
    console.log("property"+propertyName);
    this.eddunsdetails = [];
    this.eddunsdetails = this.sortArry;
    this.isCustNameSortCollapsedUpArrow = !this.isCustNameSortCollapsedUpArrow;
    this.isCustNameSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialEdiDunsMasterList, propertyName, false);
  this.eddunsdetails = [];
  this.eddunsdetails = this.sortArry;
  this.isCustNameSortCollapsedDownArrow = !this.isCustNameSortCollapsedDownArrow;
  this.isCustNameSortCollapsedUpArrow = true;
} 
   }

  }

  enablingupdate(dunsdto){
    this.isDeleted="";
    this.isdunsupdated='';
    this.updatededidunsmaster=true;
    this.addingdunsmaster=false;
    this.ediTpId =dunsdto.ediTpId;
    this.sapPayerNum = dunsdto.sapPayerNum;
    this.custName=dunsdto.custName;
  }

  updateduns(){
    this.isdunsupdated="";
    // var isSpecialChar="^[a-zA-Z0-9]+$";
    
    if(this.ediTpId == "" || this.ediTpId == null || this.ediTpId==undefined){
      this.isdunsupdated="Please Enter EDI TP ID";
      return;
    }
    if(this.sapPayerNum == "" || this.sapPayerNum == null || this.sapPayerNum==undefined){
      this.isdunsupdated="Please Enter SAP Payer No";
      return;
    }
    if(this.custName == "" || this.custName == null || this.custName==undefined){
      this.isdunsupdated="Please Enter Customer Name";
      return;
    }
    // if(!this.sapPayerNum.match(isSpecialChar)){
    //   this.isdunsupdated="Please Enter valid SAP Payer No";
    //   return;
    // }
    // if(!this.custName.match(isSpecialChar)){
    //   this.isdunsupdated="Please Enter valid Customer Name";
    //   return;
    // }
    let updatingedidunsmaster : EdiDunsMaster = new EdiDunsMaster(this.ediTpId,this.sapPayerNum,this.custName);
    this.loading=true;
    this.httpclientService.updateedidunsmaster(updatingedidunsmaster).subscribe(
      data =>{
        this.isdunsupdated=data.isSaved;
        this.loading=false;
      }
  )

  }

  cancelUpdate(){
    this.isdunsupdated="";
    this.isBlank="";
    this.modalPopup=true;
    this.isDeleted="";
  }

  clearField(){
    this.isdunsupdated="";
    this.isAdded="";
    this.isDeleted="";
  }
  
  showDialog() { 
    this.isdunsupdated=""; 
    this.confirmDialogService.confirmThis("Are you sure You want to Cancel?", function () {  
      this.updatededidunsmaster = false;
      this.getEdiDunsMaster();
    }, function () {  
       
    })  
  } 

  getEdiDunsMaster(){
    this.loading=true;
    this.httpclientService.getEdiDunsMasterDetails(this.search).then(
      data =>{ 
          this.eddunsdetails = data;
          this.intialEdiDunsMasterList= data;
          this.loading=false;
      }
  )
  }

}
